// upsell js in cart drawer
document.addEventListener('click', function(event) {
  if (event.target.closest('.upsell_products_drawer .addcart-btn')) {
    const button = event.target.closest('.addcart-btn');
    const pro_id = button.getAttribute('data-pro-id');
    const arr = [{ id: pro_id, quantity: 1 }];
    const formData = { items: arr };

    fetch('/cart/add.js', {
        body: JSON.stringify(formData),
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
        },
        method: 'POST'
    })
    .then((response) => response.json())
    .then((res) => {
        document.documentElement.dispatchEvent(new CustomEvent("cart:build"));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch((err) => {
        console.error(err);
    });
  }
});

//announcment close
document.addEventListener('click', function(event) {
  if (event.target.classList.contains('announcement-bar__close')) {
    var announcementBar = document.querySelector('.announcement-bar');
    if (announcementBar) {
      announcementBar.style.display = 'none';
    }
  }
});

//Custom Blog slider
document.addEventListener("DOMContentLoaded", function() {
  if (typeof jQuery === "undefined" || typeof jQuery.fn.flickity !== "function") return;

  jQuery(".custom-blog-sliders").flickity({
    contain: true,
    wrapAround: false,
    loop: false,
    pageDots: false
  });
});

function recomSlider() {
  if (typeof jQuery === "undefined" || typeof jQuery.fn.flickity !== "function") return;

  jQuery("[data-custom-slider]").flickity({
    watchCSS: true,
    pageDots: false,
    prevNextButtons: true,
    contain: true,
    resize: false,
    groupCells: true,
    cellAlign: "left"
  });   
}


function collecback_product_varient(){
    
    const tooltips = document.querySelectorAll("[data-popup-open]");

    const popups = document.querySelectorAll("[data-popup]");
    const closeButtons = document.querySelectorAll("[data-popup-close]");

    tooltips.forEach((tooltip) => {
        tooltip.addEventListener("click", () => {   
            const targetId = tooltip.getAttribute("data-popup-target");
            const popup = document.getElementById(targetId); 
          console.log("targetId",targetId);
            if (popup) {
              popup.classList.add("active");
              document.documentElement.classList.add("popup-active");
            }                   
        });
    });

    closeButtons.forEach((btn) => {
        btn.addEventListener("click", () => {
            popups.forEach((popup) => popup.classList.remove("active"));
          document.documentElement.classList.remove("popup-active");
        });
    });

    popups.forEach((popup) => {
        popup.addEventListener("click", (e) => {
          e.preventDefault();
            if (e.target === popup) {
              popup.classList.remove("active");
              document.documentElement.classList.remove("popup-active");
            }
           
        });
    });
}

//tooltip popup
(function() {
collecback_product_varient();
})();

function fixThirdPartyAccessibility() {
  document.querySelectorAll("label.lb-qty-selector-tier-wrapper").forEach((label) => {
    label.removeAttribute("role");
    label.removeAttribute("tabindex");
  });
}

function observeThirdPartyAccessibility() {
  fixThirdPartyAccessibility();

  const productRoot = document.querySelector("product-form, .product-form, .main-product-section");
  if (!productRoot || typeof MutationObserver === "undefined") {
    return;
  }

  const observer = new MutationObserver(() => {
    fixThirdPartyAccessibility();
  });

  observer.observe(productRoot, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", observeThirdPartyAccessibility);

